<template>
  <v-container fluid>
    <handle-out-component />
  </v-container>
</template>

<script>
import HandleOutComponent from '../components/HandleOutComponent.vue';

export default {
  name: 'HandleOutView',
  components: {
    HandleOutComponent,
  },
};
</script>
